import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { JackGirderConnection } from '@paragon/contract-library';

import { receiveRegenerateFromSettingsResponse } from './componentDesignsSlice';

export interface JackGirderConnectionsStore {
  data: {
    [guid: string]: JackGirderConnection;
  };
}

const initialState: JackGirderConnectionsStore = {
  data: {},
};

const jackGirderConnectionsSlice = createSlice({
  name: 'jackGirderConnections',
  initialState,
  reducers: {
    setJackGirderConnections: (state, action: PayloadAction<readonly JackGirderConnection[]>) => {
      for (const connection of action.payload) {
        state.data[connection.guid] = connection;
      }
    },
    loadJackGirderConnections: (state, action: PayloadAction<readonly JackGirderConnection[]>) => {
      for (const connection of action.payload) {
        state.data[connection.guid] = connection;
      }
    },
    removeJackGirderConnections: (state, action: PayloadAction<readonly string[]>) => {
      for (const jackGirderConnectionGuid of action.payload) {
        delete state.data[jackGirderConnectionGuid];
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(receiveRegenerateFromSettingsResponse, (state, action) => {
      for (const connection of action.payload.updatedGirderConnections) {
        state.data[connection.guid] = connection;
      }
    });
  },
});

export const { setJackGirderConnections, loadJackGirderConnections, removeJackGirderConnections } =
  jackGirderConnectionsSlice.actions;
export const jackGirderConnections = jackGirderConnectionsSlice.reducer;
